<template>
  <form role="form">
    <div class="vlogin-field">
      <label for="email">Correo electrónico</label>
      <div class="vlogin-field__control">
        <input id="email"
               type="email"
               name="email"
               placeholder="tu@correo.com"
               :class="{'is-error': errors.email }"
               v-model="credentials.email">
        <svg class="vlogin-field__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"></rect>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
        </svg>
      </div>
    </div>

    <div class="vlogin-field" v-if="options.password.enabled && showPasswordField">
      <label for="password">Contraseña</label>
      <div class="vlogin-field__control">
        <input id="password"
               type="password"
               name="password"
               placeholder="••••••••"
               :class="{'is-error': errors.password}"
               v-model="credentials.password">
        <svg class="vlogin-field__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      </div>
    </div>

    <button class="vlogin-btn"
            :disabled="loading"
            @click.prevent="validate">
      {{ showPasswordField ? 'Iniciar sesión' : 'Enviar enlace' }}
      <div v-if="loading" class="vlogin-spinner"></div>
    </button>
  </form>
</template>

<script>
import Validators from "./validators";
export default {
  mixins: [Validators],
  inject: ['$axios'],
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showPasswordField: true,
    loading: false
  }),
  computed: {
    url() {
      return this.showPasswordField ? this.options?.password?.url : this.options?.magicLink?.url
    },
    type() {
      return this.showPasswordField ? 'password' : 'magic link'
    }
  },
  methods: {
    changeFields() {
      this.resetErrors()
      this.showPasswordField = !this.showPasswordField;

      this.$emit('changeMode', this.showPasswordField)
    },
    resetErrors() {
      this.errors = {};
    },
    validate() {
      this.validateField('password');
      this.validateFormat('email', 'email');

      // Check that doesn't exists errors with email field
      if(Object.entries(this.errors).length === 0 && this.errors.constructor === Object) {
        this.submit();
      }
    },
    async submit() {
      if (this.loading) return;
      this.loading = true;

      if (this.url) {
        this.$axios.post(this.url, {
          administrator: { ...this.credentials, type: this.type}
        }).then(response => {
          let status = response.data;
          if (status.code >= 200 && status.code < 300) {
            this.$emit('onSubmit', { ...status, type: this.type, credentials: this.credentials })
            this.resetErrors();
          } else {
            this.$emit('onError', data)
          }
        }).catch(e => {
          this.$emit('onError', e)
        }).finally(() => {
          this.loading = false;
        })
      } else {
        console.error('No api configured for ' + this.type + ' request, options prop example: ', {
          magicLink: { enabled: true, url: 'api_url'},
          password: { enabled: true, url: 'api_url' }
        })
      }
    }
  },
  validations() {
    return this.credentialsRules;
  }
}
</script>